import React from "react";
import { Card, Row, Spinner } from "react-bootstrap";
import PrimaryButton from "../../components/PrimaryButton";
import FileUploadComponent from "../../components/FileUploadComponent";
import useDiscountViewController from "../../viewControllers/DiscountViewController";
import i18n from "../../constants/Strings";

const Discounts = () => {

  const {
    goBack,
    downloadSampleCSV,
    selectedFile,
    setSelectedFile,
    saveStatus,
    uploadFile,
    fileName,
    setFileName,
    loading
  } = useDiscountViewController();

  const text = {
    pageHeading: i18n.t('discount.pageHeading'),
    rulesHeading: i18n.t('discount.rulesHeading'),
    rulesToUpload: i18n.t('discount.rulesToUpload'),
    fileTemplateHeading: i18n.t('discount.fileTemplateHeading'),
    fileTemplate: i18n.t('discount.fileTemplate'),
    downloadBtn: i18n.t('discount.downloadBtn'),
    saveBtn: i18n.t('discount.saveBtn'),
    backBtn: i18n.t('discount.backBtn'),

  }

  return (
    <>
      <div className="container-fluid p-3 container-bg h-100">
        <div className="row">
          <div className="col-md-8">
            <h6 className="back-btn" onClick={goBack}>{text.backBtn}</h6>
            <h3 className="txt-primary">{text.pageHeading}</h3>
            <Card style={{ padding: "20px" }}>
              <h5>{text.rulesHeading}</h5>
              <ul style={{ padding: "15px 0 0 15px" }}>
                {text.rulesToUpload.map((rule, index) => (
                  <li key={index}>
                    <p style={{ textAlign: "start", color: "gray" }}>{rule}</p>
                  </li>
                ))}
              </ul>
              <div className="row d-flex justify-content-between my-2">
                <div className="col-md-12">
                  <div className="container">
                    <div className="row">
                      <div className="col">
                        <h5 style={{ textAlign: "start" }}>{text.fileTemplateHeading}</h5>
                        <h6 style={{ textAlign: "start", color: "grey" }}>
                          {text.fileTemplate}
                        </h6>
                      </div>
                      <div className="col-md-4 d-flex align-items-center justify-content-end">
                        <a
                          style={{ color: "black" }}
                          href="#"
                          onClick={downloadSampleCSV}
                        >
                          {text.downloadBtn}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-8">
            <Row>
              <div className="d-flex justify-content-center">
                <div className="px-4 w-50">
                  <FileUploadComponent
                    key={selectedFile ? selectedFile.name : ""}
                    setSelectedFile={setSelectedFile}
                    setFileName={setFileName}
                    fileName={fileName}
                    fileType={".csv"}
                  />
                </div>
                <div>
                  {loading ? <Spinner /> : (
                    <PrimaryButton
                      disabled={saveStatus}
                      type="submit"
                      text={text.saveBtn}
                      className="width-auto  "
                      onClick={uploadFile}
                    />
                  )}
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default Discounts;
